export default __webpack_public_path__ + "static/media/background.eecf7068.svg";